<template>

  <div class = "image-wrapper">
    <img :src="srclink" :width="width" :height="height" :style="css" :class="shadow ? 'uk-box-shadow-small' : null"/>

  </div>


</template>

<script>
	export default {
		name: "S3Image",
    props: {
			height: Number,
      width: Number,
      src: String,
      css: String,
      shadow: {
				type: Boolean,
        default: true,
      }
    },

		props: [
			"height",// in px
			"width", //in px
			"src", //name of the image
			"css", //css string
      "shadow" // bool for dropshadow
		],
		computed: {
			srclink: function () {
				return "https://wageup-media.s3.amazonaws.com/" + this.src
			}
		}
	}
</script>

<style lang="less" scoped>

</style>
